/**
 * Product-properties slice (SCRUM-1953, RTK bundle 4) — the former switch
 * reducer ProductPropertiesReducer.js as createSlice. Behaviour-preserving:
 * every case answers the same legacy action type string
 * (ProductPropertiesTypes.js, plus CLEAR_PRODUCTS from productTypes.js) that
 * the actions modules already dispatch, and returns the same state. The actions
 * module is unchanged, so no importer changes. `CLEAR_MESSAGE` is the same
 * string categories answers to; each slice clears its own message.
 * Characterised by tests/integration/reducers/catalogueReducers.characterisation.test.js.
 */
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  GET_ALL_PP,
  CLEAR_MESSAGE,
  GET_PP,
  GET_PRODUCTS,
  ADD_PRODUCT_PROPERTIES,
  UPDATE_PRODUCTPROPERTIES,
  CLEAR_PP,
} from "./ProductPropertiesTypes";
import { CLEAR_PRODUCTS } from "../productServices/productTypes";
import type { MessageResponse } from "../../../../shared/apiTypes";

type ProductPropertiesState = {
  productproperties: any[];
  products: any[];
  productpropertiesbyid: any;
  message: string;
};

const initialState: ProductPropertiesState = {
  productproperties: [],
  products: [],
  productpropertiesbyid: {},
  message: "",
};

const productPropertiesSlice = createSlice({
  name: "productproperties",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CLEAR_MESSAGE, (state) => ({ ...state, message: "" }))
      .addCase(GET_ALL_PP, (state, action: PayloadAction<ProductPropertiesState["productproperties"], typeof GET_ALL_PP>) => ({ ...state, productproperties: action.payload }))
      .addCase(GET_PP, (state, action: PayloadAction<ProductPropertiesState["productpropertiesbyid"], typeof GET_PP>) => ({ ...state, productpropertiesbyid: action.payload }))
      .addCase(CLEAR_PP, (state) => ({ ...state, productpropertiesbyid: {} }))
      .addCase(GET_PRODUCTS, (state, action: PayloadAction<ProductPropertiesState["products"], typeof GET_PRODUCTS>) => ({ ...state, products: action.payload }))
      .addCase(CLEAR_PRODUCTS, (state) => ({ ...state, products: [] }))
      .addCase(ADD_PRODUCT_PROPERTIES, (state, action: PayloadAction<MessageResponse, typeof ADD_PRODUCT_PROPERTIES>) => ({
        ...state,
        message: action.payload.msg,
      }))
      .addCase(UPDATE_PRODUCTPROPERTIES, (state, action: PayloadAction<MessageResponse, typeof UPDATE_PRODUCTPROPERTIES>) => ({
        ...state,
        message: action.payload.msg,
      }));
  },
});

export default productPropertiesSlice.reducer;
